module.exports = __webpack_public_path__ + "public/img/qd_lenovo、@1x.9f038fae.png";